import { Controller } from "@hotwired/stimulus";
import Cropper from "cropperjs";

// Connects to data-controller="cropper"
export default class extends Controller {
  static targets = ["x", "y", "width", "height"];
  static values = {
    initial: Object,
  };

  connect() {
    this.bind();
    document.addEventListener("turbo:morph", this.bind);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.bind);
    this.cropper?.destroy();
    this.cropper = null;
  }

  bind = () => {
    this.cropper?.destroy();
    const image = this.element.querySelector("img");
    if (!image) return;
    const controller = this;
    this.cropper = new Cropper(image, {
      viewMode: 2,
      autoCropArea: 1,
      zoomOnWheel: false,
      ready() {
        const data = controller.initialValue;
        const x = parseInt(data?.x);
        const y = parseInt(data?.y);
        const width = parseInt(data?.width);
        const height = parseInt(data?.height);
        if ([x, y, width, height].every(Number.isFinite)) {
          this.cropper.setData({ x, y, width, height });
        }
      },
      crop(event) {
        controller.xTarget.value = Math.round(event.detail.x);
        controller.yTarget.value = Math.round(event.detail.y);
        controller.widthTarget.value = Math.round(event.detail.width);
        controller.heightTarget.value = Math.round(event.detail.height);
      },
    });
  };

  reset() {
    this.cropper?.reset();
  }
}
